module.exports = __webpack_public_path__ + "fonts/Blinker-Regular.0569c7a.ttf";